import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AIAnalysisData, ColorAnalysisData, ImageAnalysisData } from '../../types';

interface AIAnalysisState {
  data: AIAnalysisData | null;
  colorData: ColorAnalysisData | null;
  imageData: ImageAnalysisData | null;
  loading: boolean;
  error: string | null;
}

const initialState: AIAnalysisState = {
  data: null,
  colorData: null,
  imageData: null,
  loading: false,
  error: null,
};

const aiAnalysisSlice = createSlice({
  name: 'aiAnalysis',
  initialState,
  reducers: {
    setAIAnalysisData: (state, action: PayloadAction<AIAnalysisData>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setColorAnalysisData: (state, action: PayloadAction<ColorAnalysisData>) => {
      state.colorData = action.payload;
      state.loading = false;
      state.error = null;
    },
    setImageAnalysisData: (state, action: PayloadAction<ImageAnalysisData>) => {
      state.imageData = action.payload;
      state.loading = false;
      state.error = null;
    },
    setAIAnalysisLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAIAnalysisError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearAIAnalysis: (state) => {
      state.data = null;
      state.colorData = null;
      state.imageData = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { 
  setAIAnalysisData, 
  setColorAnalysisData, 
  setImageAnalysisData,
  setAIAnalysisLoading, 
  setAIAnalysisError, 
  clearAIAnalysis 
} = aiAnalysisSlice.actions;
export default aiAnalysisSlice.reducer; 